import { render, staticRenderFns } from "./ChangeHub.vue?vue&type=template&id=e0d2c5fe&scoped=true&"
import script from "./ChangeHub.vue?vue&type=script&lang=js&"
export * from "./ChangeHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d2c5fe",
  null
  
)

export default component.exports